<div fxLayout="column" fxLayoutGap="16px">
  <strong>{{'forwarding.title' | translate}}</strong>
  <div fxLayout="column" *ngIf="canShowSettings()" fxLayoutGap="16px">
    <mat-radio-group [(ngModel)]="forwardingType" (ngModelChange)="updateForwardingForStatusAvailable()" fxLayout="column" fxLayoutGap="16px" [disabled]="!canEdit">
      <mat-radio-button *ngFor="let type of forwardingTypes" class="" [value]="type.key">
        <span *ngIf="type.key!==0" >{{type.text | translate}}</span>
        <mat-form-field *ngIf="type.key===0" fxLayout="row">
          <mat-select [(ngModel)]="forwardingDelay" (selectionChange)="updateForwardingDelay()" [placeholder]="type.text | translate" [disabled]="!canEdit">
            <mat-option *ngFor="let delay of forwardingDelays" [value]="delay">
              {{delay}} {{'forwarding.seconds' | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-radio-button>
    </mat-radio-group>
    <ng-container *ngIf="forwardingType !== 9">
      <strong>{{'forwarding.forwarding_number' | translate}}</strong>
      <mat-radio-group [(ngModel)]="forwardingTarget" (ngModelChange)="updateForwardingForStatusAvailable()" fxLayout="column" fxLayoutGap="16px" [disabled]="!canEdit">
        <mat-radio-button *ngFor="let type of forwardingTargets" class="" [value]="type.key">
          <mat-form-field class="numberSelection"  *ngIf="forwardingTarget === 2 && type.key === 2">
            <mat-select [(ngModel)]="colleagueNumber" (selectionChange)="changeNumber($event)" [placeholder]="type.text | translate" [disabled]="!canEdit">
              <mat-option *ngFor="let contact of colleagueNumbers" [value]="contact.phoneNumber">{{contact.name}}
                {{contact.getFormattedNumber()}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="numberSelection"  *ngIf="forwardingTarget === 3 && type.key === 3">
            <mat-select [(ngModel)]="mainNumber" (selectionChange)="changeNumber($event)" [placeholder]="type.text | translate" [disabled]="!canEdit">
              <mat-option *ngFor="let number of mainNumbers" [value]="number.phoneNumber">{{number.name}} {{number.getFormattedNumber()}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <form (ngSubmit)="changeNumber()" *ngIf="forwardingTarget === 4 && type.key === 4">
            <mat-form-field>
              <input matInput [(ngModel)]="otherNumber" [ngModelOptions]="{standalone: true}" [placeholder]="type.text | translate" [disabled]="!canEdit">
              <button mat-icon-button matSuffix matTooltip="{{'action.save_number' | translate}}" [disabled]="otherNumber.length <= 0">
                <mat-icon>save</mat-icon>
              </button>
            </mat-form-field>
          </form>

          <span *ngIf="forwardingTarget !== type.key || forwardingTarget === 1">{{type.text | translate}}</span>

        </mat-radio-button>
      </mat-radio-group>
    </ng-container>
  </div>
  <button mat-raised-button (click)="onBack()" color="primary">
    {{'global.back' | translate}}
  </button>
</div>

